import { CosmicSystem } from '~/nasa_ui/types';
export const systemNameDisplay = new Map([[CosmicSystem.ESOC, 'COSMIC']]);
export const currentSystemName = (system) => (system ? systemNameDisplay.get(system) : 'COSMIC');
